'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollButton = function (_Component) {
  (0, _inherits3.default)(ScrollButton, _Component);

  function ScrollButton() {
    (0, _classCallCheck3.default)(this, ScrollButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollButton.__proto__ || (0, _getPrototypeOf2.default)(ScrollButton)).call(this));

    _this.state = {
      intervalId: 0
    };
    return _this;
  }

  (0, _createClass3.default)(ScrollButton, [{
    key: 'scrollStep',
    value: function scrollStep() {
      if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
      }
      window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
    }
  }, {
    key: 'scrollToTop',
    value: function scrollToTop() {
      var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
      this.setState({ intervalId: intervalId });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ScrollButton.scss');
      return _react2.default.createElement(
        'button',
        {
          title: 'Back to top',
          className: styles.scroll,
          onClick: function onClick() {
            _this2.scrollToTop();
          }
        },
        _react2.default.createElement('span', {
          className: 'glyphicon glyphicon-chevron-up ' + styles.arrowUp
        })
      );
    }
  }]);
  return ScrollButton;
}(_react.Component); /* eslint-disable jsx-quotes */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable prefer-const */
/* eslint-disable react/prop-types */


exports.default = ScrollButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollButton/ScrollButton.js
// module id = 1655
// module chunks = 0